module.exports = __webpack_public_path__ + "assets/img/paper-cover-default.ed2686a7.png";